// entry.client.js
import createApp from './src/app.js';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  app.$mount('#app');
});

function updateMeta(route) {
  const meta = route.meta || {};
  const defaultDescript = `Download GB WhatsApp Pro APK latest version 2026 with installation guide, features, and safety tips.`
  const defaultKeyword = 'GB WhatsApp, GB WhatsApp Pro APK download'
  document.title = meta.title || 'GB WhatsApp Pro APK Download V18.80 (Official) Latest Version 2026';
  const defaultCanonical = 'https://gbwhatspro.chat/';

  setMetaTag('description', meta.description || defaultDescript);
  setMetaTag('og:description', meta.description || defaultDescript);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setLinkTag('canonical', meta.link?.find(link => link.rel === 'canonical')?.href || defaultCanonical);

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    // 如果不是 noindex 页面，确保 robots 标签是默认的
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
}
